import React, { useRef } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

/** Shared terminal drawer: keyboard focus, Escape, scroll lock and focus restoration. */
export default function TerminalDrawer({ title, onClose, children, width = 620, busy = false, testId }) {
  const opener = useRef(document.activeElement);
  return <Dialog.Root open onOpenChange={(open) => { if (!open && !busy) onClose?.(); }}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/60" />
      <Dialog.Content aria-describedby={undefined} data-testid={testId}
        className="terminal-drawer" style={{ "--drawer-width": `${width}px` }}
        onCloseAutoFocus={(event) => {
          if (opener.current?.isConnected) { event.preventDefault(); opener.current.focus(); }
        }}
        onEscapeKeyDown={(event) => { if (busy) event.preventDefault(); }}
        onPointerDownOutside={(event) => { if (busy) event.preventDefault(); }}>
        <div className="terminal-drawer-header">
          <Dialog.Title className="text-sm font-bold min-w-0 break-words">{title}</Dialog.Title>
          <Dialog.Close disabled={busy} aria-label={`Close ${title}`} className="terminal-icon-button shrink-0">
            <X className="h-4 w-4" aria-hidden="true" />
          </Dialog.Close>
        </div>
        <div className="terminal-drawer-body">{children}</div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>;
}
